import React, { useState, useEffect } from "react";
import Navbar1 from "./Navbar";

const CustomJewelryForm = () => {
  const [formData, setFormData] = useState({
    type: "",
    materials: "",
    engraving: "",
    name: "",
    email: "",
    phone: "",
  });

  const [formStatus, setFormStatus] = useState({ submitted: false, message: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Invia i dati a Formspree
    fetch("https://formspree.io/f/xvgpanzw", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          setFormStatus({
            submitted: true,
            message: "Grazie per aver inviato il modulo! Verrai contattato al più presto.",
          });
        } else {
          setFormStatus({ submitted: true, message: "Errore nell'invio del modulo. Riprova." });
        }
      })
      .catch((error) => {
        console.error("Errore:", error);
        setFormStatus({ submitted: true, message: "Errore nell'invio del modulo. Riprova." });
      });
  };

  // Scroll automatico verso l'alto quando il componente viene montato
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <>
      <Navbar1 />
      <div className="form-container" style={{ marginTop: "100px", marginBottom: "30px" }}>
        <h2 style={{ marginTop: "50px" }}>Crea il tuo gioiello</h2>
        <p>
          Compila il form e crea il tuo gioiello. Fornisci delle informazioni dettagliate, e noi trasformeremo ogni tua
          idea in realtà.
        </p>
        {formStatus.submitted && (
          <div
            className="form-message"
            style={{ marginBottom: "20px", color: formStatus.message.includes("Errore") ? "red" : "green" }}
          >
            {formStatus.message}
          </div>
        )}
        <form onSubmit={handleSubmit} className="custom-form">
          <div>
            <label htmlFor="type">Tipologia gioiello *</label>
            <input type="text" id="type" name="type" value={formData.type} onChange={handleChange} required />
          </div>
          <div>
            <label htmlFor="materials">Caratteristiche e materiali *</label>
            <textarea id="materials" name="materials" value={formData.materials} onChange={handleChange} required />
          </div>
          <div>
            <label htmlFor="engraving">Incisione desiderata *</label>
            <textarea id="engraving" name="engraving" value={formData.engraving} onChange={handleChange} required />
          </div>
          <div>
            <label htmlFor="name">Nome e Cognome *</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
          </div>
          <div>
            <label htmlFor="email">Indirizzo email *</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div>
            <label htmlFor="phone">Telefono</label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} />
          </div>
          <div className="button-container">
            <button type="submit" className="small-button">
              Invia
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CustomJewelryForm;
